module.exports = __webpack_public_path__ + "html/dat-api.template.html";